module.exports = __webpack_public_path__ + "8ed351b537408bd47510f0919899d130.svg";